import { FC } from "react";
import { Button, Card, Space } from "antd";
import { CalendarOutlined } from "@ant-design/icons";

const maintenanceData = [
  {
    vehicle: "SPRINTER-01",
    type: "Regular Service",
    due: "May 15, 2023",
    tasks: ["Oil change", "Tire rotation", "Brake inspection"],
  },
  {
    vehicle: "TRUCK-02",
    type: "Regular Service",
    due: "April 20, 2023",
    tasks: ["Oil change", "Filters", "System check"],
  },
  {
    vehicle: "VAN-01",
    type: "In Service",
    completion: "March 12, 2023",
    issue: "Engine overheating issue",
  },
];

export const MaintenanceSchedule: FC = () => {
  return (
    <Card
      title="Maintenance Schedule"
      className="rounded-lg border border-gray-200"
      headStyle={{ fontWeight: 500 }}
    >
      <Space direction="vertical" size="middle" className="w-full">
        {maintenanceData.map((item, idx) => (
          <Card
            key={idx}
            className={`rounded-lg border ${
              item.vehicle === "VAN-01"
                ? "border-red-200 bg-red-50"
                : "border-gray-200"
            }`}
          >
            <div className="flex justify-between items-center">
              <div
                className={`font-medium ${
                  item.vehicle === "VAN-01" ? "text-red-800" : ""
                }`}
              >
                {item.vehicle}
              </div>
              <span
                className={`text-sm ${
                  item.vehicle === "VAN-01" ? "text-red-600" : "text-gray-500"
                }`}
              >
                {item.type}
              </span>
            </div>
            <div className="mt-2 text-sm">
              {item.due ? (
                <>
                  <div>Due: {item.due}</div>
                  <div className="flex items-center text-gray-500 space-x-2 mt-1">
                    {item.tasks?.map((task, i) => (
                      <span key={i}>
                        {task}
                        {i < (item.tasks?.length || 0) - 1 && " • "}
                      </span>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <div>Expected completion: {item.completion}</div>
                  <div className="text-red-600 mt-1">{item.issue}</div>
                </>
              )}
            </div>
          </Card>
        ))}
        <Button
          icon={<CalendarOutlined />}
          className="w-full flex items-center justify-center border-gray-300 hover:bg-gray-50"
        >
          Schedule Maintenance
        </Button>
      </Space>
    </Card>
  );
};
